import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Modal from '@Components/Common/Modal';
import TX from '@Components/Common/Text';
import Button from '@Components/Common/Button';

const NoticeDeleteChoiceModal = ({
  isNoticeDeleteChoiceModalVisible,
  handleDeleteChoiceButtonOfModalClick,
  handleIsNoticeDeleteChoiceModalVisible,
}) => {
  return (
    <Modal visible={isNoticeDeleteChoiceModalVisible} handleCloseButtonClick={handleIsNoticeDeleteChoiceModalVisible}>
      <ModalContentContainer>
        <ModalTitle>선택지 삭제</ModalTitle>
        <ModalContent>
          선택지가 하나도 없으면, 이 페이지는
          <br />
          마지막 페이지로 지정됩니다.
        </ModalContent>

        <ModalButtonContainer>
          <Button
            text="취소"
            textColor="#0A0A0A"
            backgroundColor="#F2F2F3"
            style={{ marginRight: '12px' }}
            onClick={handleIsNoticeDeleteChoiceModalVisible}
          />
          <Button text="삭제" onClick={handleDeleteChoiceButtonOfModalClick} />
        </ModalButtonContainer>
      </ModalContentContainer>
    </Modal>
  );
};

NoticeDeleteChoiceModal.propTypes = {
  isNoticeDeleteChoiceModalVisible: PropTypes.bool.isRequired,
  handleDeleteChoiceButtonOfModalClick: PropTypes.func.isRequired,
  handleIsNoticeDeleteChoiceModalVisible: PropTypes.func.isRequired,
};

const ModalContentContainer = styled.div`
  display: flex;
  align-items: center;

  flex-direction: column;
`;

const ModalTitle = styled(TX.Title1)`
  margin-bottom: 13px;
`;

const ModalContent = styled(TX.BodyM)`
  line-height: 24px;
  text-align: center;
  margin-bottom: 24px;

  color: ${({ theme }) => theme.colors.ui_on_2};
`;

const ModalButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export default NoticeDeleteChoiceModal;
